/* eslint-disable @typescript-eslint/no-explicit-any */
import { Input } from "components/ui/input";
import { Label } from "components/ui/label";
import { format } from "date-fns";
import { ptBR } from "date-fns/locale";

export function ExceptionCreated({ data }: { data: any[] }) {
  return (
    <>
      {data.map((item, i) => {
        const displayCode = item.type === "PRODUCT" ? item.sku : item.ncm;

        const newInitial = item.newInitialTerm ?? item.new_initial_term;
        const oldInitial = item.oldInitialTerm ?? item.old_initial_term;
        const newFinal = item.newFinalTerm ?? item.new_final_term;
        const oldFinal = item.oldFinalTerm ?? item.old_final_term;

        return (
          <div
            key={i}
            className="border p-4 rounded-md bg-gray-50 mb-4 grid grid-cols-3 gap-4"
          >
            <div className="flex flex-col gap-1">
              <Label className="text-sm text-gray-900">Estado</Label>
              <Input
                value={item.state === "all" ? "TODOS" : item.state}
                disabled
                className="bg-gray-100 h-10 text-gray-900"
              />
            </div>

            <div className="flex flex-col gap-1">
              <Label className="text-sm text-gray-900">
                {item.type === "PRODUCT" ? "SKU" : "NCM"}
              </Label>
              <Input
                value={displayCode === "all" ? "TODOS" : displayCode}
                disabled
                className="bg-gray-100 h-10 text-gray-900"
              />
            </div>

            <div className="flex flex-col gap-1">
              <Label className="text-sm text-gray-900">Tributo</Label>
              <Input
                value={item.exception_type}
                disabled
                className="bg-gray-100 h-10 text-gray-900"
              />
            </div>

            <div className="flex flex-col gap-1">
              <Label className="text-sm text-gray-900">Alíquota</Label>
              <Input
                value={
                  item.exception_rate != null
                    ? `${item.exception_rate.toString().replace(".", ",")}%`
                    : "-"
                }
                disabled
                className="bg-gray-100 h-10 text-gray-900"
              />
            </div>

            <div className="flex flex-col gap-1">
              <Label className="text-sm text-gray-900">
                Início de Vigência (novo)
              </Label>
              <Input
                value={
                  newInitial
                    ? format(new Date(newInitial), "dd/MM/yyyy", {
                        locale: ptBR,
                      })
                    : "-"
                }
                disabled
                className="bg-gray-100 h-10 text-gray-900"
              />
            </div>

            <div className="flex flex-col gap-1">
              <Label className="text-sm text-gray-900">
                Início de Vigência (anterior)
              </Label>
              <Input
                value={
                  oldInitial
                    ? format(new Date(oldInitial), "dd/MM/yyyy", {
                        locale: ptBR,
                      })
                    : "Não havia vigência anterior"
                }
                disabled
                className="bg-gray-100 h-10 text-gray-900"
              />
            </div>

            <div className="flex flex-col gap-1">
              <Label className="text-sm text-gray-900">
                Fim de Vigência (novo)
              </Label>
              <Input
                value={
                  newFinal
                    ? format(new Date(newFinal), "dd/MM/yyyy", {
                        locale: ptBR,
                      })
                    : "Não informado"
                }
                disabled
                className="bg-gray-100 h-10 text-gray-900"
              />
            </div>

            <div className="flex flex-col gap-1">
              <Label className="text-sm text-gray-900">
                Fim de Vigência (anterior)
              </Label>
              <Input
                value={
                  oldFinal
                    ? format(new Date(oldFinal), "dd/MM/yyyy", {
                        locale: ptBR,
                      })
                    : "Não havia vigência anterior"
                }
                disabled
                className="bg-gray-100 h-10 text-gray-900"
              />
            </div>
          </div>
        );
      })}
    </>
  );
}
